module.exports = __webpack_public_path__ + "img/marker-icon03@2x.79f76d8f.png";